export default __webpack_public_path__ + "static/media/telesaleshelp-summary.3d842138.PNG";